"use client";

import { ArrowUpRight, Lightbulb, Thermometer, Projector } from "lucide-react";
import { Button } from "@/components/ui/button";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function Specificationimagemanager() {
  const {
    ref: headerRef,
    isVisible: headerVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.2
  });
  const {
    ref: cardsRef,
    isVisible: cardsVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.1
  });
  const pillars = [{
    number: "01",
    icon: Lightbulb,
    titleTop: "ACERO",
    titleBottom: "ESTRUCTURAL",
    description: "Soluciones de alta resistencia para edificaciones industriales. Vigas y columnas diseñadas para soportar las cargas más exigentes.",
    offset: "lg:translate-y-0"
  }, {
    number: "02",
    icon: Thermometer,
    titleTop: "PROCESOS",
    titleBottom: "TÉRMICOS",
    description: "Control preciso de temperatura en la fabricación. Garantizamos la integridad molecular y durabilidad de cada perfil de acero.",
    offset: "lg:-translate-y-6"
  }, {
    number: "03",
    icon: Projector,
    titleTop: "INGENIERÍA",
    titleBottom: "AVANZADA",
    description: "Visualización técnica y precisión milimétrica. Transformamos planos complejos en estructuras sólidas y seguras.",
    offset: "lg:translate-y-0"
  }];
  return;
}